import Input from '../../components/input/input';
import Button from '../../components/button/button';
import Alert from '../../components/alert/alert';
import LogoSmall from '../../assets/logo-small.svg';
import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import AuthService from '../../services/auth-service';
import { TOKEN, SESSION, TEAM } from '../../constants';
import LocalStorage from '../../services/local-storage';
import TranslateService from '../../services/translate-service';

export default function Login() {

    const navigate = useNavigate();


    const getWindowDimensions = () => {
        const { innerWidth: width, innerHeight: height } = window;
        return {
          width,
          height
        };
    }

    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

    const [form, setForm] = useState({
        email: '',
        password: '',
        isValid: false
    })
    const [request, setRequest] = useState({
        errorMessage: '',
        isSending: undefined
    })


    const handleInput = (field, value) => {
        let copyForm = {...form};

        copyForm[field] = value;
        copyForm.isValid = copyForm.email && copyForm.password;

        setForm(copyForm);
    }

    const login = async (event) => {
        event.preventDefault();

        try {
            setRequest({errorMessage: '', isSending: true })
            const response = await AuthService.login(form.email, form.password);

            LocalStorage.set(TOKEN, response.token);
            LocalStorage.set(TOKEN, response.token);
            LocalStorage.set(TEAM, response.equipo);
            LocalStorage.set(SESSION, response.perfil);

            navigate('/', { replace: true });

        } catch (error) {
            setRequest({errorMessage: error.message, isSending: false })
        }
    }


    useEffect(() => {
        const handleResize = () => {
          setWindowDimensions(getWindowDimensions());
        }
    
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
      }, []);
    

    return (
        <div className="grid grid-cols-1 md:grid-cols-2" style={{ height: `${windowDimensions.height}px`}}>
            <div className=" bg-login-doodle relative hidden md:block">
                <div className='absolute bottom-14 left-24'>
                    <div className=''>
                        <div>
                            <h1 className='text-white font-semibold text-[108px] leading-[132px] '>Welcome</h1>
                            <h1 className='text-white font-semibold text-[108px] leading-[132px] mb-8'>back!</h1>
                            <p className='text-white text-[12px]'>Powered by Loftmedia Latam</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="grid grid-cols-12 gap-[16px] mx-[32px] md:grid-cols-6 md:mx-[0px]">
                <div className="col-span-12 md:col-span-4 md:col-start-2">
                    <div className='flex justify-center items-center '  style={{ height: `${windowDimensions.height}px`}}>
                        <form className='w-full'  onSubmit={login} >
                            <img src={LogoSmall} className="mb-5"  alt=""  />
                            <h1 className='heading-h4 mb-5'>{TranslateService.get('login.title')}</h1>
                            <p className='mb-5'>{TranslateService.get('login.description')}</p>
                            
                            <Input className="mb-6" type='email' label={TranslateService.get('login.label.email')}  value={form.email} onChange={ (event) => handleInput('email', event.target.value)} />
                            <Input className="mb-6" type='password' label={TranslateService.get('login.label.password')}  value={form.password} onChange={ (event) => handleInput('password', event.target.value)}/>

                            {request.errorMessage && <Alert className="mb-6" text={request.errorMessage} /> }                           

                            <div className='mb-6'>
                                <Link to="/auth/forgot-password" className='link'>{TranslateService.get('login.link')}</Link>
                            </div>
                            
                            <Button onClick={login} disabled={!form.isValid || request.isSending }>
                                {request.isSending && <FontAwesomeIcon icon={faSpinner} spin={true} />}  {TranslateService.get('login.btn')}
                            </Button>
                            
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

